import { IntlShape } from "react-intl";

import { OccurrenceImportResponse, OccurrenceImportValidationResponse } from "../models/occurrenceImport";

import ApiService from "../services/api";

export const getOccurrenceImportTemplate = async (intl: IntlShape): Promise<{ errorMessage: string | null; successMessage: string | null } | undefined> => {
    const apiService = new ApiService();
    try {
        const response = await apiService.get<Blob>(`/occurrences/import/template`, {
            responseType: 'blob',
        });

        if (response.status >= 200 && response.status < 300 && response.data) {
            const contentDisposition = response.headers?.["content-disposition"] || response.headers?.["Content-Disposition"];

            let filename = "chamados_modelo.xlsx";
            if (typeof contentDisposition === "string") {
                const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
                const plainMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
                const rawFilename = utf8Match?.[1] || plainMatch?.[1];
                if (rawFilename) {
                    filename = decodeURIComponent(rawFilename);
                }
            }

            const blob = response.data instanceof Blob
                ? response.data
                : new Blob([response.data as BlobPart]);

            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(downloadUrl);

            return { errorMessage: null, successMessage: intl.formatMessage({ id: "occurrence.downloadTemplate.successMessage" }) };
        } else {
            return { errorMessage: intl.formatMessage({ id: "occurrence.downloadTemplate.errorMessage" }), successMessage: null };
        }
    } catch (error) {
        console.error("Error download template file:", error);
        return { errorMessage: intl.formatMessage({ id: "occurrence.downloadTemplate.errorMessage" }), successMessage: null };
    }
    return undefined;
}

export const validateOccurrenceImportFile = async (file: File, intl: IntlShape): Promise<OccurrenceImportValidationResponse> => {
    const apiService = new ApiService();
    const formData = new FormData();
    formData.append("file", file);

    try {
        const response = await apiService.post(`/occurrences/import/validate`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        if (response.status >= 200 && response.status < 300) return response.data as OccurrenceImportValidationResponse;

        return { valid: false, message: intl.formatMessage({ id: "occurrence.import.validationError" }), totalLines: 0, errors: [] };
    } catch (error) {
        console.error("Error validating import file:", error);
        return { valid: false, message: intl.formatMessage({ id: "occurrence.import.validationError" }), totalLines: 0, errors: [] };
    }
}

export const importOccurrenceFile = async (file: File, intl: IntlShape): Promise<OccurrenceImportResponse> => {
    const apiService = new ApiService();
    const formData = new FormData();
    formData.append("file", file);

    try {
        const response = await apiService.post(`/occurrences/import`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        if (response.status >= 200 && response.status < 300) return response.data as OccurrenceImportResponse;

        return { imported: 0, failed: 0, errors: [] };
    } catch (error) {
        console.error("Error importing file:", error);
        return { imported: 0, failed: 0, errors: [] };
    }
}